import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AppSettings, UpdateSettingsInput } from '@accounting/shared';
import { api } from '../lib/api';

export const settingsKey = ['settings'] as const;

export function useSettings() {
  return useQuery({
    queryKey: settingsKey,
    queryFn: () => api.get<{ settings: AppSettings }>('/settings').then((r) => r.settings),
  });
}

export function useUpdateSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateSettingsInput) =>
      api.put<{ settings: AppSettings }>('/settings', input).then((r) => r.settings),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: settingsKey });
      qc.invalidateQueries({ queryKey: ['report', '1099-nec'] });
    },
  });
}
